var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.544 20.6902C25.544 21.1463 25.1743 21.516 24.7182 21.516C24.2621 21.516 23.8924 21.1463 23.8924 20.6902C23.8924 20.2342 24.2621 19.8644 24.7182 19.8644C25.1743 19.8644 25.544 20.2342 25.544 20.6902Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7182 12.157V17.6624M21.415 7.8412H8C6.89543 7.8412 6 8.73663 6 9.8412V24.5594C6 25.664 6.89543 26.5594 8 26.5594H22.7182C23.8228 26.5594 24.7182 25.664 24.7182 24.5594V23.7183",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3143 7.78348L25.238 5.70711C24.8474 5.31658 24.2143 5.31658 23.8237 5.70711L16.0185 13.5124C15.8789 13.652 15.7837 13.8298 15.745 14.0233L15.2259 16.6188C15.086 17.3185 15.7029 17.9355 16.4026 17.7955L18.9981 17.2764C19.1917 17.2377 19.3695 17.1425 19.5091 17.0029L27.3143 9.19769C27.7049 8.80716 27.7049 8.174 27.3143 7.78348Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearn);
export default __webpack_public_path__ + "static/media/learn.cb27a43677b8c553f312873c3e8c0317.svg";
export { ForwardRef as ReactComponent };